"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateStreamingPlatformDto = instanceOfCreateStreamingPlatformDto;
exports.CreateStreamingPlatformDtoFromJSON = CreateStreamingPlatformDtoFromJSON;
exports.CreateStreamingPlatformDtoFromJSONTyped = CreateStreamingPlatformDtoFromJSONTyped;
exports.CreateStreamingPlatformDtoToJSON = CreateStreamingPlatformDtoToJSON;
exports.CreateStreamingPlatformDtoToJSONTyped = CreateStreamingPlatformDtoToJSONTyped;
/**
 * Check if a given object implements the CreateStreamingPlatformDto interface.
 */
function instanceOfCreateStreamingPlatformDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('display_order' in value) || value['display_order'] === undefined)
        return false;
    return true;
}
function CreateStreamingPlatformDtoFromJSON(json) {
    return CreateStreamingPlatformDtoFromJSONTyped(json, false);
}
function CreateStreamingPlatformDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'display_order': json['display_order'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}
function CreateStreamingPlatformDtoToJSON(json) {
    return CreateStreamingPlatformDtoToJSONTyped(json, false);
}
function CreateStreamingPlatformDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'display_order': value['display_order'],
        'is_active': value['is_active'],
    };
}
